import {
  FEMaterial,
  ThermalPerformanceLayer,
  ToitEnPenteConfigurationState,
  ToitEnPenteThermalPerformanceState,
  initialToitEnPenteThermalPerformanceState,
} from "@iko-design-center/shared"

export function updateThermalLayer(
  thermalPerformance: ToitEnPenteThermalPerformanceState,
  material: FEMaterial,
  type: string
) {
  const draft: ToitEnPenteThermalPerformanceState = {
    ...thermalPerformance,
  }
  // @ts-ignore
  draft[type] = getThermalPerformanceLayer(material)
  return calculateThermalPerformance(draft)
}

export function getThermalPerformance(
  state: ToitEnPenteConfigurationState
): ToitEnPenteThermalPerformanceState {
  const thermalPerformance = {
    ...initialToitEnPenteThermalPerformanceState,
  }

  thermalPerformance.toitInsulation = getThermalPerformanceLayer(
    state.toitInsulation.material!
  )

  return calculateThermalPerformance(thermalPerformance)
}

function calculateThermalPerformance(
  state: ToitEnPenteThermalPerformanceState
): ToitEnPenteThermalPerformanceState {
  const draft = { ...state }
  let isComplete = true

  ;["toitInsulation"].forEach((layer: string) => {
    // @ts-ignore
    const { thickness, lambda } = draft[layer] as ThermalPerformanceLayer

    if (thickness && lambda) {
      // @ts-ignore
      draft[layer] = {
        thickness,
        lambda,
        RValue: parseFloat(
          (Math.floor(thickness / 1000 / lambda / 0.05) * 0.05).toFixed(2)
        ),
      }
    } else {
      isComplete = false
    }
  })

  if (isComplete) {
    draft.RTValue = parseFloat(
      // RSI +
      (draft.toitInsulation.RValue!)
      // RSE
      .toFixed(2)
    )
    draft.UCValue = parseFloat((1 / draft.RTValue).toFixed(2))
  }
  return draft
}

function getThermalPerformanceLayer(
  material: FEMaterial
): ThermalPerformanceLayer {
  const isVariable =
    material.lambdaThicknessThresholds &&
    material.lambdaThicknessThresholds.length > 0 &&
    material.lambdas.length > 1

  const thickness = material.thickness
  let lambda: number

  if (!isVariable) {
    lambda = material.lambdas[0]
  } else {
    material.lambdaThicknessThresholds!.forEach(
      (threshold: any, index: any) => {
        if (thickness > threshold) {
          lambda = material.lambdas[index + 1]
        }
      }
    )
  }

  return {
    thickness,
    lambda: lambda!,
    RValue: null,
  }
}
